let menuDataMain = [
    //{ icon: "home", name: "Home", screenName: "Home", key: '0' },
    { icon: "list", name: "Feed", screenName: "Home", key: '0' },
    { icon: "log-in", name: "Sign In/Sign Up", screenName: "Signin/Signup", key: '1' },
    { icon: "settings", name: "Settings", screenName: "Settings", key: '2' },
];

export { menuDataMain };